/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMetadataExport = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 2h10.414l7.96 7.96-9.286 10.446L2 12.454zm2 2v7.546l6.912 6.048 6.714-7.554L11.586 4zm3.5 3.5h-2v-2h2zm4 2H10v-2h3.5V11h-2zm-2 .5v1.5H11v2H7.5V10zm9.5 4.586 3.707 3.707-1.414 1.414L20 18.414V22h-2v-3.586l-1.293 1.293-1.414-1.414z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgMetadataExport as MetadataExport };
